/* ForgeHeavy — footer column accordion (mobile only).

   The columns render as <details open> so desktop is correct on first paint with no JS
   and no CSS override. This script's ONLY job is to collapse them below 750px, and to
   re-open them if the viewport crosses back to desktop.

   Deliberately NOT tied to a resize/reflow for the desktop case: if this script never
   runs (JS disabled, error, slow load), every column stays open, which is the correct
   desktop state and a readable mobile fallback. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var cols = document.querySelectorAll('.fh-ft__col');
  if (!cols.length) return;

  function apply(isMobile) {
    for (var i = 0; i < cols.length; i++) {
      if (isMobile) {
        // First column stays open by design; the rest collapse.
        if (i === 0) cols[i].setAttribute('open', '');
        else cols[i].removeAttribute('open');
      } else {
        // Desktop is always fully expanded, whatever the user did on mobile.
        cols[i].setAttribute('open', '');
      }
    }
  }

  apply(mq.matches);

  if (mq.addEventListener) mq.addEventListener('change', function (e) { apply(e.matches); });
  else if (mq.addListener) mq.addListener(function (e) { apply(e.matches); });
})();
